export default __webpack_public_path__ + "static/financial-professional-v3-fdc953dad0bbae2a85eaa95d2f3a11b7.svg";